import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {Router, ActivatedRoute} from '@angular/router';
import {AuthService} from 'src/app/services/auth.service';
import {finalize, takeWhile} from 'rxjs/operators';
import {protectedPages} from '../../app/models/protectedPages';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  private loggedOut = false;
  constructor(
      private auth: AuthService,
      private route: Router,
      private activeRoute: ActivatedRoute
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request)
      .pipe(catchError((err: HttpErrorResponse) => {
        switch (err.status) {
          case 401: {
                this.auth.logout().pipe(
                    takeWhile(() => !this.loggedOut),
                    finalize(() => {
                      if(!this.route.url.startsWith('/login')) {
                        this.route.navigate(['/login'],{ queryParams: { returnurl: this.getReturnUrlFrom(this.route.url) } });
                      }
                    }),
                ).subscribe(() => {
                    this.loggedOut = true;
                });
                return throwError(err);
          }
          // case 403: {
          //   this.route.navigate(['/login/mfa'],
          //   {
          //     queryParams: { returnurl: this.getReturnUrlFrom(this.route.url) }
          //   });
          //   return throwError(err);
          // }
        }
        return throwError(err);
      }));
  }

    private getReturnUrlFrom(url: string): string {
         if(url === "/login" || url == "/login/mfa" || url == "/login/mfa/enroll") {
           url = this.activeRoute.snapshot.queryParams['returnurl'] 
         }
  
        if(url === "/")
          url = '';

        console.log(url);
        return url || null;
  }
}
